enum FilesUploadingError {
  STORAGE_LIMIT_EXCEEDED = 'StorageLimitExceeded',
  ENTITY_TOO_LARGE = 'EntityTooLarge',
  ENTITY_TOO_SMALL = 'EntityTooSmall',
  OFFLINE = 'Offline',
  COMMON = 'Common',
}

export default FilesUploadingError;
